import React from 'react';
import { IonIcon } from '@ionic/react';

export type AdminTone = 'green' | 'blue' | 'violet' | 'orange' | 'red' | 'grey' | 'brown';

// Ícono (o inicial) de color al principio de cada fila de las listas del
// backoffice: de un vistazo se ve qué es cada cosa y en qué estado está.
const AdminRowIcon: React.FC<{ icon?: string; initial?: string; tone: AdminTone }> = ({ icon, initial, tone }) => (
  <span slot="start" className={`admin-row-icon tone-${tone}${initial ? ' is-avatar' : ''}`} aria-hidden="true">
    {initial ?? (icon && <IonIcon icon={icon} />)}
  </span>
);

export default AdminRowIcon;
